import { Map } from 'immutable';
import createAction from '../../../../utils/redux-helpers/createAction';

const handler = (state, { data }) => state.set('postalCodes', Map(data));

export const setPostalCodes = createAction({
  action: ['setPostalCodes', 'data'],
  handler,
});
